export default __webpack_public_path__ + "static/media/subtract.00ac2cb0.svg";